module.exports = __webpack_public_path__ + "img/16.167476c8.jpg";